export const BlankTemplate = {
  type: 'doc',
  content: [
    {
      type: 'paragraph',
      attrs: {
        nodeIndent: null,
        nodeTextAlignment: null,
        nodeLineHeight: null,
        style: '',
      },
    },
  ],
};
